import request from ".";

export const programsApi = {
  getPrograms: () => request.post(`AcademicsProg/getALLAcademicsProgHome`),
  getCenterPrograms: (UniqueUrl: string) =>
    request.post(`CentersProg/getCentersProgByUrl?UniqueUrl=${UniqueUrl}`),
  getTraineeCV: (id: string) =>
    request.post(
      `TraningStudents/getTraningStudentsByProgramUniqeUrl?UniqueUrl=${id}`
    ),
  getProgramById: (id: string) =>
    request.post(`OfficesProg/getOfficesProgByUniqueUrl?UniqueUrl=${id}`),
};
